import { theme } from '@frontend/theme';
import { Avatar, styles, Text } from '@frontend/design-system';

type Props = {
  image: string | undefined;
  name: string | undefined;
  title: string | undefined;
};

export const IncomingCallBarHead = ({ name, image, title }: Props) => {
  return (
    <>
      <Avatar name={name} size='small' src={image} />
      <Text
        color='white'
        css={[
          styles.truncate,
          { width: '100%', display: 'block', boxSizing: 'border-box', paddingLeft: theme.spacing(0.5) },
        ]}
      >
        {title}
      </Text>
      <Text color='white'>Calling</Text>
    </>
  );
};
